import { useState } from 'react';
import { COMPANY } from '../content/copy';

const FORMSPREE = 'https://formspree.io/f/xkokbpav';

const PERSONAL_DOMAINS = new Set([
  'gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 'live.com',
  'icloud.com', 'aol.com', 'protonmail.com', 'mail.com', 'ymail.com',
  'rediffmail.com', 'yahoo.in', 'yahoo.co.in', 'googlemail.com', 'me.com',
]);

export function isBusinessEmail(email) {
  const d = email.split('@')[1]?.toLowerCase();
  return d && !PERSONAL_DOMAINS.has(d);
}

const empty = { name: '', email: '', company: '', message: '' };

export default function ContactForm({ heading = true }) {
  const [form, setForm] = useState(empty);
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState('idle');

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = 'Name required';
    if (!form.email.trim()) e.email = 'Email required';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = 'Enter a valid email address';
    else if (!isBusinessEmail(form.email)) e.email = 'Please use a business email';
    if (!form.company.trim()) e.company = 'Company required';
    if (!form.message.trim()) e.message = 'Tell us about the work';
    return e;
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    setStatus('sending');
    try {
      const res = await fetch(FORMSPREE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      setStatus(res.ok ? 'success' : 'error');
    } catch {
      setStatus('error');
    }
  };

  const set = (field) => (ev) => {
    setForm((p) => ({ ...p, [field]: ev.target.value }));
    setErrors((p) => ({ ...p, [field]: undefined }));
  };

  if (status === 'success') {
    return (
      <div className="bv-form-success">
        <div className="bv-form-check" aria-hidden="true">✓</div>
        <h3>Message received.</h3>
        <p>We will be in touch shortly.</p>
      </div>
    );
  }

  return (
    <form className="bv-form" onSubmit={handleSubmit} noValidate>
      {heading && (
        <div className="bv-form-head">
          <p className="bv-eyebrow">Contact</p>
          <h2 className="bv-h3">Work with Black Vanilla</h2>
          <p className="bv-muted">Tell us about the environment, robot, or industrial process you need spatial intelligence for.</p>
        </div>
      )}
      <label>
        <span>Full name</span>
        <input type="text" value={form.name} onChange={set('name')} aria-invalid={!!errors.name} />
        {errors.name && <em>{errors.name}</em>}
      </label>
      <label>
        <span>Company</span>
        <input type="text" value={form.company} onChange={set('company')} aria-invalid={!!errors.company} />
        {errors.company && <em>{errors.company}</em>}
      </label>
      <label>
        <span>Business email</span>
        <input type="email" value={form.email} onChange={set('email')} aria-invalid={!!errors.email} />
        {errors.email && <em>{errors.email}</em>}
      </label>
      <label>
        <span>How can we help?</span>
        <textarea rows={4} value={form.message} onChange={set('message')} aria-invalid={!!errors.message} />
        {errors.message && <em>{errors.message}</em>}
      </label>
      <button type="submit" className="bv-btn bv-btn-solid bv-btn-block" disabled={status === 'sending'}>
        {status === 'sending' ? 'Sending…' : 'Send message'}
      </button>
      {status === 'error' && (
        <p className="bv-form-error">Something went wrong — email {COMPANY.email} directly.</p>
      )}
      <p className="bv-form-note">Business emails only · {COMPANY.email}</p>
    </form>
  );
}
